<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="所属基地" prop="land_base_name">
              <Input disabled="disabled" class="perW30" v-model="infoData.land_base_name"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所属地块" prop="land_sn">
              <Input disabled="disabled" class="perW30" v-model="infoData.land_sn"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="投入品种类" prop="manure">
              <Input disabled="disabled" class="perW30" v-model="infoData.manure"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="施肥重量(kg)" prop="weight">
              <Input disabled="disabled" class="perW20" v-model="infoData.weight"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="施肥日期" prop="date">
              <Input disabled="disabled" class="perW20" v-model="infoData.date"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="投入金额" prop="amount">
              <Input disabled="disabled" class="perW30" v-model="infoData.amount"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" disabled="disabled" class="perW30" v-model="infoData.remark"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="操作人" prop="operator">
              <Input disabled="disabled" class="perW30" v-model="infoData.operator"></Input>
            </FormItem>
          </Col>

        </Row>
      </Form>
    </card>

  </div>
</template>
<script>
import {plantManureInfoApi} from '@/api/plant/plantManure'

export default {
  name: 'plantManureInfo',
  data() {
    return {
      infoData: {
        id: 0,
        land_base_name: '',
        land_sn: '',
        manure: '',
        weight: 0,
        date: '',
        amount: 0,
        remark: '',
        operator: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadFormData(id) {
      plantManureInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
